module.exports = __webpack_public_path__ + "img/contact.6c09542a.png";